import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { SectionHeading } from "@italymondo/core-ui";

export const Heading = styled(SectionHeading)`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.respTextAlign};
  `}
`;
